export function confirmationStatusesToMap(confirmationStatuses) {
    return confirmationStatuses.reduce((acc, { UserId, Status }) => {
        acc[UserId] = Status;
        return acc;
    }, {});
}
